import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { StyledActionCard, StyledActionCardActions, StyledActionCardContent, StyledActionCardDescription, StyledActionCardHeader, StyledActionCardTitle } from './styles';
import { type ActionCardProps } from './types';
import { ACTION_CARD_CLASS_NAME } from './classNames';
import Divider from '../Divider';
const ActionCard = t0 => {
  const $ = _c(17);
  const {
    ref,
    title,
    variant,
    description,
    actions,
    actionsEmptyState
  } = t0;
  const hasActions = actions != null && actions.length > 0;
  const footerContent = hasActions ? actions : actionsEmptyState;
  let t1;
  if ($[0] !== title || $[1] !== variant) {
    t1 = <StyledActionCardTitle variant="h5" actionCardVariant={variant}>{title}</StyledActionCardTitle>;
    $[0] = title;
    $[1] = variant;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1 || $[4] !== variant) {
    t2 = <StyledActionCardHeader variant={variant}>{t1}</StyledActionCardHeader>;
    $[3] = t1;
    $[4] = variant;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== description) {
    t3 = <StyledActionCardDescription>{description}</StyledActionCardDescription>;
    $[6] = description;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== footerContent) {
    t4 = footerContent != null ? <><Divider /><StyledActionCardActions>{footerContent}</StyledActionCardActions></> : null;
    $[8] = footerContent;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = <StyledActionCardContent>{t3}{t4}</StyledActionCardContent>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== ref || $[14] !== t2 || $[15] !== t5) {
    t6 = <StyledActionCard ref={ref} className={ACTION_CARD_CLASS_NAME}>{t2}{t5}</StyledActionCard>;
    $[13] = ref;
    $[14] = t2;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
export default ActionCard;
export { ActionCard };
export type { ActionCardProps, ActionCardVariant } from './types';